import React from 'react';

import { IndeterminateValue, isIndeterminate, PropertySelectField } from '@paragon/client-tools';
import {
  TRUSS_DEFINITION_TYPES,
  TrussDefinitionType,
  TrussType,
  VALID_DEFINITION_TYPES,
} from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

interface Props {
  value: TrussDefinitionType | IndeterminateValue;
  trussType: TrussType | IndeterminateValue;

  onChange(value: TrussDefinitionType): void;

  disabled?: boolean;
}

export function getDisabledDefinitionTypesForComponentType(componentType: TrussType): readonly TrussDefinitionType[] {
  return TRUSS_DEFINITION_TYPES.filter(
    (definitionType) => !VALID_DEFINITION_TYPES[componentType].includes(definitionType),
  );
}

export function TrussDefinitionTypeSelect({ onChange, trussType, value, disabled }: Props) {
  return (
    <PropertySelectField<TrussDefinitionType>
      margin="normal"
      property="Definition Type"
      disabled={disabled}
      value={value}
      allowUnknownValues={isIndeterminate(value)}
      options={TRUSS_DEFINITION_TYPES}
      disabledOptions={isIndeterminate(trussType) ? ['Profile'] : getDisabledDefinitionTypesForComponentType(trussType)}
      getName={humanCase}
      submit={onChange}
    />
  );
}
